import React from 'react';
import PropTypes from 'prop-types';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import { TARGET_FIELDS_PROP_TYPE } from 'shared/constants/PropTypes';

const textStyle = {
  fontSize: 13
};

class MapListItem extends React.PureComponent {
  handleSelectChange = (event, key, currentValue) => {
    const { mappingActions: { setMappedFields }, sourceName, subGroup, selectedTarget, activeDivision } = this.props;
    setMappedFields(sourceName, currentValue, subGroup, selectedTarget, activeDivision);
  };

  requiredItemLabel = targetItem => ( targetItem.required ? `${targetItem.label} (Required)` : `${targetItem.label}` );
  
  render(){
    const { sourceName, targetFields, selectedTarget } = this.props;
    const defaultLabel = "Select Column Label";
    return (
      <div className="map-columns__list-item">
        <div className="map-columns__source-field">{ sourceName }</div>
        <div className="map-columns__equal">=</div>
        <SelectField
          hintText={ defaultLabel }
          style={ { width: 400 } }
          maxHeight={ 300 }
          iconStyle={ { fill: '#aaa' } }
          hintStyle={ textStyle }
          menuItemStyle={ textStyle }
          labelStyle={ textStyle }
          value={ selectedTarget }
          onChange={ this.handleSelectChange }
        >
          <MenuItem value={ null } primaryText={ defaultLabel } style={ { color: '#bcbcbc' } } />
          {
            targetFields.map(target => (
              <MenuItem 
                key={ target.name } 
                value={ target.name } 
                primaryText={ this.requiredItemLabel(target) } 
                disabled={  target.disabled } 
              />
            ))
          }
        </SelectField>
      </div>
    );
  }
}

MapListItem.propTypes = {
  activeDivision: PropTypes.number,
  selectedTarget: PropTypes.string,
  sourceName: PropTypes.string.isRequired,
  targetFields: TARGET_FIELDS_PROP_TYPE.isRequired,
  subGroup: PropTypes.string,
  mappingActions: PropTypes.shape({
    setMappedFields: PropTypes.func
  }).isRequired
};

MapListItem.defaultProps = {
  activeDivision: 0,
  subGroup: '',
  selectedTarget: ''
};

export default MapListItem;



// WEBPACK FOOTER //
// ./src/shared/components/mapColumns/c/columnListsSlidingPanel/c/columnLists/c/mapListItem/MapListItem.js